export interface IpAddress {
    ip_address: string;
    first_seen: string;
}

export interface User {
    user_id: number;
    user_name: string;
    user_email?: string;
    user_phone?: string;
    registration_time?: string;
    registration_time_unix: number;
    user_registration_timestamp: string;
    user_balance: number;
    bonus_balance?: number;
    user_currency?: string;
    user_role: string;
    user_firstname?: string;
    user_lastname?: string;
    banned: boolean;
    hidden?: boolean;
    deposit_rate: number;
    deposit_enabled: boolean;
    withdrawal_enabled: boolean;
    only_players: boolean;
    tenant_id_list?: number[];
    ip_address_list?: IpAddress[];
    parent_tree?: {
        user_id: number;
        user_role: string;
        user_name: string;
    }[];
}

export enum UserRole {
    PLATFORM,
    OWNER,
    SUPERADMIN,
    ADMIN,
    CASHIER,
    PLAYER,
    AGENT
}